/**
 * API Configuration
 *
 * All configuration comes from environment variables.
 * See .env file
 *
 * IMPORTANT: Variables must be prefixed with VITE_ to work in the browser!
 */

// Read from environment variables
// export const API_BASE_URL =
//   import.meta.env.VITE_API_URL ||
//   'https://joethog6a0.execute-api.us-east-1.amazonaws.com/dev';

// export const API_NAME =
//   import.meta.env.VITE_APP_NAME ||
//   'ZuzHQ';

// export const ENV =
//   import.meta.env.VITE_ENV ||
//   'local';

const local = {
  API_BASE_URL: 'https://joethog6a0.execute-api.us-east-1.amazonaws.com/dev',
  API_NAME: 'ZuzHQ',
  ENV: 'local',
  GOOGLE_MAP: {
    apiKey: 'AIzaSyDNCvvWY_uagpagFNS8ALCB4UO7nPTPO1c',
  }
}

const dev = {
  API_BASE_URL: 'https://joethog6a0.execute-api.us-east-1.amazonaws.com/dev',
  API_NAME: 'ZuzHQ',
  GOOGLE_MAP: {
    apiKey: 'AIzaSyB9mP_ERxl5xNNn_8gnp7-6Y6mVK4jcWFw',
  },
  ENV: 'dev',
}

const production = {
  API_BASE_URL: 'https://joethog6a0.execute-api.us-east-1.amazonaws.com/prod',
  API_NAME: 'ZuzHQ',
  GOOGLE_MAP: {
    apiKey: 'AIzaSyB9mP_ERxl5xNNn_8gnp7-6Y6mVK4jcWFw',
  },
  ENV: 'production',
}
const env = import.meta.env.VITE_ENV || 'local';
export const ENV = env;
// Helper functions
export const isDevelopment = env === 'dev';
export const isProduction = env === 'production';
export const isLocal = env === 'local';
export const VERSION = "2026-04-17.01";

// Default export for backward compatibility
export default isDevelopment ? dev : isProduction ? production : local;

